import InfoIcon from '@mui/icons-material/InfoOutlined'
import Tooltip from '@mui/material/Tooltip'
import { memo } from 'react'
import styles from './TallImageWarning.pcss'

export interface TallImageWarningProps {
  withWrapper?: boolean
  className?: string
}

export const TallImageWarning = ({ withWrapper, className }: TallImageWarningProps) => {
  const textClassName = !withWrapper ? className : ''

  const text = (
    <span className={`${styles['tall-image-sign']} ${textClassName}`}>
      tall image
      <Tooltip title="Full image will post. Only preview is cropped.">
        <InfoIcon className={styles['icon-info']} />
      </Tooltip>
    </span>
  )

  return withWrapper ? (
    <div className={`${styles.wrapper} ${className}`}>
      {text}
    </div>
  ) : (
    text
  )
}

export default memo(TallImageWarning)
